import React from 'react';
import PageShell from '../Components/ui/PageShell';
import RecruiterTlRequirementDetailsSection from '../Components/admin/RecruiterTlRequirementDetailsSection';

function RecruiterTlRequirementDetailsPage() {
  return (
    <PageShell
      title="Recruiter / TL Requirement Details"
      subtitle="View recruiter and team lead requirement assignments and client details."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Reports', path: '/reports' },
        { label: 'Recruiter / TL Requirement Details' },
      ]}
      backTo="/reports"
    >
      <RecruiterTlRequirementDetailsSection />
    </PageShell>
  );
}

export default RecruiterTlRequirementDetailsPage;
